import LoadingKeys from '@/constants/core/LoadingKeys'
import { VuexResponse } from '@/helpers/vuex-action-builder'
import FormSubmissionWithSchemaVM from '@/models/forms/formSubmissionWithSchemaVM'

const getDefaultState = () => {
  return {}
}

const state = getDefaultState()

export default {
  namespaced: true,
  state,
  getters: {
    isLoadingFormSubmission: (state, getters, rootState, rootGetters) =>
      rootGetters.isLoadingByKey(LoadingKeys.forms.loadingFormSubmission),
    isLoadingFormFile: (state, getters, rootState, rootGetters) => (fileId) =>
      rootGetters.isLoadingByKey(fileId),
  },
  mutations: {
    CLEAR_STORE(state) {
      // Resets store to default state
      Object.assign(state, getDefaultState())
    },
  },
  actions: {
    async loadFormSubmission({ commit }, passkey) {
      return await new VuexResponse(commit)
        .request(() =>
          this.$api.forms.getFormSubmissionAndSchemaByPasskey(passkey)
        )
        .withLoadingByKey(LoadingKeys.forms.loadingFormSubmission)
        .transform((data) => new FormSubmissionWithSchemaVM(data))
        .go()
    },
    async downloadFile({ commit }, { passkey, fileId }) {
      return await new VuexResponse(commit)
        .request(() => this.$api.forms.downloadFile(passkey, fileId))
        .withLoadingByKey(fileId)
        .withContentDisposition()
        .go()
    },
    /**
     * Resets store to default state.
     */
    clear({ commit }) {
      commit('CLEAR_STORE')
    },
  },
}
